<template>
    <div>
        <h3>Finish</h3>
        <p>
            Your payment has been accepted.
        </p>
        <p>
            Your payment Id is {{ store.paymentId }}
        </p>
        <p>
            You will receive an email receipt with your payment information shortly.
        </p>
    </div>
</template>

<script setup>
    import { useStore } from './store';

    const store = useStore();
</script>